const state = {
  shifts: [],
  processing: false,
};

export default state;
